import { Col, Row } from 'antd'
import React from 'react'
import ByMuvu from '../../../PatientLandingGeneralComponents/ByMuvu'

export default function SurveyDisclaimer({ examName }) {
  return (
    <Row className='border-container mt-40'>
      <Col span={24}>
        <h2 className="mb-0 text-center text-orange"><strong>¡Importante!</strong></h2>
      </Col>
      <Col span={24}>
        <p className='mb-0 mt-20 text-center'>
          <strong>Para comenzar te invitamos a completar tu {examName || 'encuesta de salud'}, la que podrás retomar durante todo el proceso de la toma de tus exámenes.</strong>
        </p>
      </Col>
      <Col span={24}>
        <p className='mb-0 mt-20 text-center'>
          Te recomendamos leer con atención cada pantalla, podrás revisar y editar tus respuestas.
        </p>
      </Col>
    </Row>
  )
}
